module.exports = __webpack_public_path__ + "img/2-3.6ed2557a.png";